export default "__VITE_ASSET__27510e7d__"